import { TextLink } from '@vds/buttons';
import { Line } from '@vds/lines';
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import TextField from "@mui/material/TextField";
import styled from 'styled-components';
import { addSpace, getDestList } from '../../shared/utils/globalUtils';
import { useGetDevicesUnauthByNameQuery } from '../../features/devicesAndPlans/plansFetch'
import { TileContainer } from '@vds/tiles';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ErrorPage from '../../shared/components/ErrorPage';
import Footer from '../../shared/components/Footer';
import Header from '../../shared/components/Header';
import FullPageLoader from '../../shared/components/Loader';
import { setRetainDatesAndDestinations,updateSelectedPlanData } from '../../features/selectedData/selectedDataReducer';
import { saveSelectedDeviceDetailsUnauth,setOnlyCruise, saveConfirmedPlanData } from '../../features/selectedData/persistantDataReducer';
import { isDesktop, isTab, unauth } from '../../shared/utils/globalConfig';

const DevicePageMainUnauth = styled.div`
`
const DevicePageUnauth = styled.div`

`
const Space = styled.div`
padding-top: ${props => props.pt || 12}px;
`
const StyledBlock = styled.div`
display: flex;
gap: 3px;
p {
min-width: 75px;
}
`
const StyledBox = styled.div`
display:${isDesktop? "grid":""};
grid-template-columns: ${isDesktop? 'repeat(6, 1fr)':''};
`
const StyledTile = styled.div`
div[class^="OuterMostWrapper-VDS__sc-"] {
   
    border :${props => props.pt == props.ct?  '2px solid black' : ""};
    border-radius:${props => props.pt == props.ct?  '10px' : ""};;
  }

  div[class^="OuterMostWrapper-VDS__sc-"] {
   
    border :${props => props.pt == props.ct?  '2px solid black' : ""};
    border-radius:${props => props.pt == props.ct?  '10px' : ""};;
  }
`

const StyledDiv = styled.div`
display:${isDesktop? "":"flex"};
gap: 20px;
padding: :${isDesktop? '10% 0% 10% 10%':'0px'};
`
const StyledImageDevice = styled.img`
height: ${isDesktop? '80px':'50px'};
padding:${isDesktop? '0% 0% 35% 25%':'0px'};
`;

export default function DevicesAndPlans() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDestinations, selectedDates } = useSelector(state => state?.persistantReducer);

    const getDevicesPayload = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate
        }
        return payload;
    }

    const { data, error, isLoading, isSuccess } = useGetDevicesUnauthByNameQuery(getDevicesPayload(),
    { skip: selectedDestinations?.length === 0 || selectedDates?.travelStartDate ==undefined && selectedDates?.travelEndDate ==undefined});
    const [isInput, setIsInput] = useState();
    const [isMatchesFound,setMatchesFound] =useState(false); 
    const [indexVal, setIndex] = useState();
    const [Data, setData] = useState([]);
    const [deviceUnauthData, setDeviceUnauthData] = useState();
    let isCruiseAirplaneOnly = (selectedDestinations && selectedDestinations.length == 2 && selectedDestinations.filter((item) => item.key === "CSP" || item.key === "AAA").length == 2) ? true : false;
    let isCruiseOnly = (selectedDestinations && selectedDestinations.length == 1 && selectedDestinations.filter((item) => item.key === "CSP").length == 1) ? true : false;
    useEffect(() => {
        if (unauth) {
            dispatch(saveConfirmedPlanData([]));
            dispatch(updateSelectedPlanData({}));
        }
        setDeviceUnauthData(data?.body?.data?.devices)
        if (!(selectedDestinations.length === 0 || selectedDates?.travelStartDate ==undefined && selectedDates?.travelEndDate ==undefined))  
        {dispatch(setRetainDatesAndDestinations(true));}
    }, [data]);

    useEffect(() => {
        if (selectedDestinations.length === 0 || selectedDates?.travelStartDate ==undefined && selectedDates?.travelEndDate ==undefined) {
            navigate('/', { replace: true })
        }

    }, [selectedDestinations])


    let inputHandler = (e) => {
        if (e.target.value) {
            const filteredData = deviceUnauthData?.deviceDetails?.filter((deviceIteams) => (
                deviceIteams?.brandName?.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
                ||deviceIteams?.deviceDisplayName?.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
                ||deviceIteams?.deviceCategory?.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
                ||deviceIteams?.brandName?.concat(" ",deviceIteams?.deviceDisplayName).toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
                
            ));
            setMatchesFound(true)
            setData(filteredData);
        }
        else{
            setData([]);
            setIsInput(false);
        }

    };

    
    const onSelectDevice = (deviceDetails, index) => {
        dispatch(saveSelectedDeviceDetailsUnauth(deviceDetails));
        setIsInput(true);
        setIndex(index) 

    }
    const OnNextButtonClicks = () => {
        if(isCruiseAirplaneOnly || isCruiseOnly)
        {
            dispatch(setOnlyCruise(true))
            navigate("/uaitpcruiseplan");

        }
        else{
        dispatch(setOnlyCruise(false))
        navigate(deviceUnauthData?.ctaList[0]?.ctaUrl);}
    }
    const openEditTripLink = (ctaUrl) => {
        navigate(-2, {replace:true})

    }
    return (
        <DevicePageMainUnauth id="device_page">
            {(isSuccess && deviceUnauthData) ?
                (
                    <DevicePageUnauth >
                        <Header data-testid="pageTitleId" pageTitle={deviceUnauthData?.pageTitle} progressData={deviceUnauthData?.progressBar}></Header>
                        <Title size="large" >{deviceUnauthData?.heading}</Title>
                        <Space />
                        <Body size="large">{deviceUnauthData?.travelDates}</Body>
                        <StyledBlock><Body size="large">{deviceUnauthData?.travelLabel}</Body>
                            <Body size="large" bold={true}>{addSpace(deviceUnauthData?.travelingCountries, ',')}</Body>
                        </StyledBlock>
                        <Space />
                        <TextLink onClick={() => { openEditTripLink(deviceUnauthData?.editTripCtaList[0].ctaUrl) }}>{deviceUnauthData?.editTripCtaLabel}</TextLink>
                        <Space pt={24} />
                        <Line type="secondary" />
                        <Space pt={24} />
                        <Title size="large">{deviceUnauthData?.tripSubHeading}</Title>
                        <Space />
                        <Body size="large">{deviceUnauthData?.subHeadingText}</Body>
                        <Space pt={24} />
                        <Body regularWeight="light" size="small">{deviceUnauthData?.searchText}</Body>
                        <Space pt={7} />
                        <TextField
                            data-testid="textFields"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={inputHandler}
                            color='primary'
                            fullWidth = {(isDesktop || isTab) ? false: true}
                            label={deviceUnauthData?.txtLabel}
                        />
                        <Space pt={5} />
                        <Body regularWeight="light" size="large" light >{deviceUnauthData?.compatibilityText}</Body>
                        <Space pt={40} />
                        <>
                            {isMatchesFound  && <Body size="medium" bold>Showing {Data?.length} items</Body>}
                            <Space />

                            <StyledBox>
                                {Data?.map((option, index) => {
                                    return (<StyledTile pt={index} ct={indexVal}>

                                        <TileContainer
                                        aspectRatio= {isDesktop ?'3:4':'4:1'}
                                        width= {isDesktop ? '200px' : '100%'} 
                                        showBorder
                                        onClick={e => onSelectDevice(option, index)}
                                        backgroundColor="white"
                                        showDropShadow
                                        >
                                            <StyledDiv id='Deb'>
                                                <StyledImageDevice src={option?.deviceImageUrl}></StyledImageDevice>
                                                <div><Body size="medium" bold>{option?.brandName}</Body><Body size="medium" bold>{option?.deviceImageAlt}</Body></div>
                                            </StyledDiv>
                                        </TileContainer>
                                        <Space /></StyledTile>
                                        );
                                })}
                            </StyledBox> </>
                        <Footer ctaLabel={deviceUnauthData?.ctaList[0]?.ctaLabel} handleButtonChange={OnNextButtonClicks} disabled={!isInput} btn={true}></Footer>
                    </DevicePageUnauth>)
                : (error && <ErrorPage errorDetails={error?.data} />
                )}
            {isLoading && <FullPageLoader />}
        </DevicePageMainUnauth>
    )
} 